import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import router from '@/router'
import store from '@/store'
import JwtService from '@/common/jwt.service'
// import {
//     LOGOUT
// } from '@/store/actions.type'
import {
    API_URL
} from '@/common/config'
import {
    SET_LOADING
} from '@/store/mutations.type'
var numberOfCAllsPending = 0
var endpointsToIgnore = [
    'compilation'
]
const ApiService = {
    init () {
        Vue.use(VueAxios, axios)
        Vue.axios.defaults.baseURL = API_URL
        Vue.axios.interceptors.request.use(function (config) {
            if (endpointsToIgnore.indexOf(config.url.replace(API_URL + '/', '')) === -1) numberOfCAllsPending++
            store.commit(SET_LOADING, numberOfCAllsPending)
            return config
        }, function (error) {
            if (endpointsToIgnore.indexOf(error.config.url.replace(API_URL + '/', '')) === -1) numberOfCAllsPending--
            store.commit(SET_LOADING, numberOfCAllsPending)
            return Promise.reject(error)
        })
        Vue.axios.interceptors.response.use(function (response) {
            if (endpointsToIgnore.indexOf(response.config.url.replace(API_URL + '/', '')) === -1) numberOfCAllsPending--
            store.commit(SET_LOADING, numberOfCAllsPending)
            return response
        }, function (error) {
            if (endpointsToIgnore.indexOf(error.config.url.replace(API_URL + '/', '')) === -1) numberOfCAllsPending--
            store.commit(SET_LOADING, numberOfCAllsPending)
            if (error.response) {
                if (error.response.status === 401) {
                    // store.dispatch(LOGOUT)
                    // location.reload()
                }
                if (error.response.status === 404) {
                    // router.push('/404')
                }
            }
            return Promise.reject(error)
        })
    },

    setHeader () {
        Vue.axios.defaults.headers.common['Authorization'] = `Token ${JwtService.getToken()}`
    },

    query (resource, params) {
        return Vue.axios
            .get(resource, params)
            .catch((error) => {
                throw error
            })
    },

    get (resource) {
        return Vue.axios
            .get(`${resource}`)
            .catch((error) => {
                throw error
            })
    },

    post (resource, params) {
        return Vue.axios.post(`${resource}`, params)
    },

    update (resource, params) {
        return Vue.axios.put(`${resource}`, params)
    },

    put (resource, params) {
        return Vue.axios
            .put(`${resource}`, params)
    },

    delete (resource) {
        return Vue.axios
            .delete(resource)
            .catch((error) => {
                throw error
            })
    }
}

export default ApiService

export const ArticleService = {
    query (params) {
        return ApiService
            .query(
                'articles', {
                    params: params
                }
            )
    },
    get (id) {
        return ApiService.get(`articles/${id}`)
    },
    create (params) {
        return ApiService.post('articles', {
            article: params
        })
    },
    update (params) {
        return ApiService.put(`articles/${params.id}`, {
            article: params
        })
    },
    delete (id) {
        return ApiService.delete(`articles/${id}`)
    }
}

export const ProjectService = {
    query (params) {
        return ApiService
            .query(
                'projects', {
                    params: params
                }
            )
    },
    get (id) {
        return ApiService.get(`projects/${id}`)
    },
    create (params) {
        return ApiService.post('projects', {
            project: params
        })
    },
    update (params) {
        return ApiService.put(`projects/${params.id}`, {
            project: params
        })
    },
    delete (id) {
        return ApiService.delete(`projects/${id}`)
    }
}

export const TasksService = {
    query (type, params) {
        return ApiService
            .query(
                'tasks', {
                    params: params
                }
            )
    },
    get (id) {
        return ApiService.get(`tasks/${id}`)
    },
    create (params) {
        return ApiService.post('tasks', {
            task: params
        })
    },
    update (params) {
        return ApiService.put(`tasks/${params.id}`, {
            task: params
        })
    },
    delete (id) {
        return ApiService.delete(`tasks/${id}`)
    }
}

export const TypeService = {
    get () {
        return ApiService.get('types')
    }
}

export const MetasService = {
    query (params) {
        return ApiService
            .query(
                'metas', {
                    params: params
                }
            )
    }
}

export const UsersService = {
    get (id) {
        return ApiService.get(`users/${id}`)
    },
    query (params) {
        return ApiService
            .query(
                'users', {
                    params: params
                }
            )
    },
    create (params) {
        return ApiService.post('users', {
            user: params
        })
    },
    update (params) {
        return ApiService.put(`users/${params.id}`, {
            user: params
        })
    },
    delete (id) {
        return ApiService.delete(`users/${id}`)
    },
    picture (id, file) {
        return ApiService.post(`users/${id}/picture`, file)
    }
}

export const WavesService = {
    query (params) {
        return ApiService
            .query(
                'wave', {
                    params: params
                }
            )
    },
    create (wave) {
        return ApiService.post('wave',
            wave
        )
    },
    update (wave) {
        return ApiService.put(`wave/${wave.id}`,
            wave
        )
    }
}

export const SurveysService = {
    get (id) {
        return ApiService.get(`survey/${id}`)
    },
    query (params) {
        return ApiService
            .query(
                'survey', {
                    params: params
                }
            )
    }
}

export const CompilationService = {
    insert (compilation) {
        return ApiService.post('compilation',
            compilation
        )
    },
    query (params) {
        return ApiService
            .query(
                'compilation', {
                    params: params
                }
            )
    },
    remove (id) {
        return ApiService.delete(`compilation/${id}`)
    }
}

export const AttachmentService = {
    query (params) {
        return ApiService
            .query(
                'attachments', {
                    params: params
                }
            )
    },
    create (attachment) {
        return ApiService.post('attachments', attachment)
    },
    remove (id) {
        return ApiService.delete(`attachments/${id}`)
    }
}

export const MessagesService = {
    query (params) {
        return ApiService
            .query(
                'messages', {
                    params: params
                }
            )
    },
    create (message) {
        return ApiService.post('messages', {
            message: message
        })
    },
    get (id) {
        return ApiService.get(`messages/${id}`)
    },
    delete (id) {
        return ApiService.delete(`messages/${id}`)
    },
    update (message) {
        return ApiService.put(`messages/${message.id}`,
            {
                message: message
            }
        )
    }
}

export const UploadService = {
    upload (file) {
        return ApiService.post('upload',
            file
        )
    }
}

export const StatsService = {
    get (type, params) {
        let endpoint = 'stats'
        if (type) endpoint+= `/${type}`
        return ApiService
            .query(
                endpoint, {
                    params: params
                }
            )
    }
}
